// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1VM95","notes":"Notes_notes__1vN4l"};